<template>
  <div class="crew-no-show container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="My crew never showed up" /></div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <p>
          It’s common for services to be rescheduled due to weather, equipment maintenance or other
          unforseen circumstances.
        </p>
        <p>If more than a day has passed beyond the scheduled service date, please let us know</p>
        <form test-id="reschedule_form" novalidate @submit.prevent="requestReschedule">
          <LsInput
            v-model="message"
            type="textarea"
            track-id="crew_no_show_view-message"
            placeholder="Send us a message..."
            name="message"
          />
          <LsButton
            test-id="request_a_reschedule"
            text="REQUEST A RESCHEDULE"
            bg-color="tertiary"
            track-id="crew_no_show_view-request_a_reschedule"
            type="submit"
            :loading="support.loadingStatus.isUpdating"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton, LsInput } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { SUPPORT__SUBMIT_MESSAGE } from '@/store/types';
import { SUPPORT_MESSAGE_TYPES } from '@/constants';
import { LsSupportHeader } from '../components';

export default {
  name: 'CrewNoShowView',
  components: {
    LsButton,
    LsInput,
    LsSupportHeader,
  },
  data() {
    return {
      message: '',
    };
  },
  computed: {
    ...mapState(['support']),
  },
  methods: {
    ...mapActions([SUPPORT__SUBMIT_MESSAGE]),
    requestReschedule() {
      this[SUPPORT__SUBMIT_MESSAGE]({
        message: this.message,
        issue: SUPPORT_MESSAGE_TYPES.CREW_NEVER_SHOWED_UP,
        onSuccess: () => {
          this.$router.push({ name: 'support' });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.crew-no-show {
  h1 {
    margin-bottom: 20px;
  }

  button {
    margin-top: 20px;
  }

  .chevron {
    vertical-align: bottom;
    margin-right: 3px;
    transform: rotate(180deg);
  }

  .back-link-container {
    margin-bottom: 19px;
    @media (max-width: $mobile-max-width) {
      padding-bottom: 15px;
      border-bottom: 1px solid $primary-light;
    }
  }

  .back-link {
    color: $primary;
    font-weight: bold;
  }

  p:not(:last-child) {
    margin-bottom: 16px;
  }
}
.themed-app {
  .crew-no-show {
    .back-link-container {
      @media (max-width: $mobile-max-width) {
        border-color: $theme-color-primary-light;
      }
    }
    .back-link {
      color: $theme-color-primary;
    }
  }
}
</style>
